<template>
  <div
    v-if="html"
    class="text-tags"
    :class="[`size-${size}`]"
    v-html="html"
  />
  <div
    v-else
    class="text-tags"
    :class="[`size-${size}`]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'UiTextTags',
  props: {
    html: { type: String },
    size: {
      type: String,
      default: 'default',
      validator: (v) => ['default', 'small'].includes(v),
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
